import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import ImgGallery from '@common/ImgGallery'
import styles from './style.module.less'
import { toJS } from 'mobx'
import store from './store'
import { observer } from 'mobx-react'
import { Radio, Input, Button, MagicInput } from 'hljd'
import { JUKE_PATH_A } from '@constant'
import { Link } from 'react-router'

const RadioGroup = Radio.Group
const { TextArea } = Input

@observer
export default class extends Component {
  render() {
    let header = [<Link to="JUKE_PATH_A">聚客宝</Link>, '申请活动']

    let property_id = 2

    let content_desc = ''
    switch (+property_id) {
      case 2:
        content_desc =
          '请简要填写您要发起活动的形式及内容（500字以内），例如：婚礼手绘图免费送、婚礼沙龙门票0元抢、婚礼方案到店就送等等。请在方案中详述活动的所有利益点和限制条件，尽量避免误解或遗漏'
        break
      case 6:
        content_desc =
          '请简要填写您要发起活动的形式及内容（500字以内），例如：最美证件照免费拍、最新场景免费试拍、感恩父母婚纱照限量送等等。请在方案中详述活动的所有利益点和限制条件，尽量避免误解或遗漏'
        break
      case 12:
        content_desc =
          '请简要填写您要发起活动的形式及内容（500字以内），例如：全场免费试纱、样衣特卖会、头纱DIY等等。请在方案中详述活动的所有利益点和限制条件，尽量避免误解或遗漏'
        break
      case 7:
        content_desc =
          '请简要填写您要发起活动的形式及内容（500字以内），例如：领证跟拍免费送、最美证件照免费拍等等。请在方案中详述活动的所有利益点和限制条件，尽量避免误解或遗漏'
        break
      case 8:
        content_desc =
          '请简要填写您要发起活动的形式及内容（500字以内），例如：领证跟拍免费送、婚前采访视频免费送等等。请在方案中详述活动的所有利益点和限制条件，尽量避免误解或遗漏'
        break
      case 9:
        content_desc =
          '请简要填写您要发起活动的形式及内容（500字以内），例如：免费试妆/试纱、新娘妆发小课堂等等。请在方案中详述活动的所有利益点和限制条件，尽量避免误解或遗漏'
        break
      case 11:
        content_desc =
          '请简要填写您要发起活动的形式及内容（500字以内），例如：冷门档期特价抢订、婚礼歌单免费定制、新人誓词量身定制等等。请在方案中详述活动的所有利益点和限制条件，尽量避免误解或遗漏'
        break
      case 14:
        content_desc =
          '请简要填写您要发起活动的形式及内容（500字以内），例如：预约到店送情侣对戒、裸钻定制超低折扣等等。请在方案中详述活动的所有利益点和限制条件，尽量避免误解或遗漏'
        break
      case 15:
        content_desc =
          '请简要填写您要发起活动的形式及内容（500字以内），例如：手捧花DIY、甜品蛋糕DIY等等。请在方案中详述活动的所有利益点和限制条件，尽量避免误解或遗漏'
        break
    }

    const {
      title,
      has_prize,
      people_limit,
      activity_time,
      content,
      imgs,
      merchant_info,
      visit_gift,
      comment_gift,
      order_gift,
      disabled
    } = store

    return (
      <HeaderView title="申请活动" header={header}>
        <div className={styles.box}>
          <div className={styles.what}>
            <p>什么样的活动吸引用户?看看其他商家怎么做活动</p>
            <a href={`${JUKE_PATH_A}/example`}>查看活动范例></a>
          </div>

          <div className={styles.item}>
            <span className={styles.label}>活动主题</span>
            <p className={styles.inline}>
              例如:周年店庆、新品发布、新春特惠等,最终主题文案由婚礼纪运营优化并决定
            </p>
            <div className={styles.write}>
              <MagicInput
                style={{ width: 400 }}
                value={title}
                maxLength={30}
                showCount
                countPosition="inner"
                onChange={e => store.changeField('title')(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.item}>
            <span className={styles.must}>是否抽奖</span>
            <p className={styles.inline}>
              抽奖由婚礼纪平台系统进行,您将获得中奖用户的联系方式,并向中奖用户兑现承诺
            </p>
            <div className={styles.write}>
              <RadioGroup
                value={has_prize}
                onChange={store.changeInput('has_prize')}
              >
                <Radio value={0}>不抽奖</Radio>
                <Radio value={1}>抽奖</Radio>
              </RadioGroup>
            </div>
          </div>

          <div className={styles.item}>
            <span className={styles.must}>活动名额</span>
            <p className={styles.inline}>
              即本次活动的报名数量上限,报名人数一旦达到上限,其他用户将无法继续报名,且活动将于近日结束并下线
            </p>
            <div className={styles.write}>
              <Input
                style={{ width: 190 }}
                placeholder={'正整数'}
                value={people_limit}
                onChange={store.changeInput('people_limit')}
              />
              &nbsp;&nbsp;人
            </div>
          </div>

          <div className={styles.item}>
            <span className={styles.must}>活动时间</span>
            <p className={styles.inline}>
              活动在线下的有效期,如:2016.10.1-10.7/即日起至2017.12.31/2017.1.15下午14:00-17:00
            </p>
            <div className={styles.write}>
              <MagicInput
                style={{ width: 400 }}
                value={activity_time}
                maxLength={30}
                showCount
                countPosition="inner"
                onChange={e =>
                  store.changeField('activity_time')(e.target.value)
                }
              />
            </div>
          </div>

          <div className={styles.item}>
            <span className={styles.must}>活动内容</span>
            <p className={styles.inline}>{content_desc}</p>
            <div className={styles.write}>
              <TextArea
                rows={5}
                style={{ width: 500, marginRight: 10 }}
                value={content}
                onChange={store.changeInput('content')}
              />
              <span
                style={{ color: content.length > 500 - 5 ? '#f50' : '#666' }}
              >
                {content.length}
                <span style={{ color: '#999' }}>/500</span>
              </span>
            </div>
          </div>

          <div className={styles.item}>
            <span className={styles.label}>活动图片</span>
            <p className={styles.inline}>
              建议上传一些经典作品图、活动相关的礼品图、美观有特色的店面图、个人形象照(四大金刚)
            </p>
            <div className={styles.write}>
              <ImgGallery
                max={10}
                keyField="img"
                multiple={true}
                showUpload={imgs.length < 10}
                onRemove={store.removeImg}
                onOk={store.AddImg}
                imgList={toJS(imgs)}
              />
            </div>
          </div>

          <div className={styles.item}>
            <span className={styles.must}>商家简介</span>
            <p className={styles.inline}>
              为了更好的向用户宣传贵店,请发挥您的才能简单介绍一下贵店
            </p>
            <div className={styles.write}>
              <TextArea
                rows={5}
                style={{ width: 500, marginRight: 10 }}
                value={merchant_info}
                onChange={store.changeInput('merchant_info')}
              />
              <span
                style={{
                  color: merchant_info.length > 100 - 5 ? '#f50' : '#666'
                }}
              >
                {merchant_info.length}
                <span style={{ color: '#999' }}>/100</span>
              </span>
            </div>
          </div>

          <div className={styles.other}>
            <span style={{ color: '#333' }}>其他信息</span>
            <span style={{ color: '#999' }}>
              （以下礼品将只针对报名且到店的用户，非中奖用户也可以领取。如填写，请勿与店铺本身到店礼、订单礼重复）
            </span>
          </div>

          <div className={styles.item}>
            <span className={styles.label}>到店礼</span>
            <MagicInput
              style={{ width: 560 }}
              value={visit_gift}
              maxLength={50}
              showCount
              countPosition="inner"
              onChange={e => store.changeField('visit_gift')(e.target.value)}
            />
          </div>

          <div className={styles.item}>
            <span className={styles.label}>好评礼</span>
            <MagicInput
              style={{ width: 560 }}
              value={comment_gift}
              maxLength={50}
              showCount
              countPosition="inner"
              onChange={e => store.changeField('comment_gift')(e.target.value)}
            />
          </div>

          <div className={styles.item}>
            <span className={styles.label}>下单礼</span>
            <MagicInput
              style={{ width: 560 }}
              value={order_gift}
              maxLength={50}
              showCount
              countPosition="inner"
              onChange={e => store.changeField('order_gift')(e.target.value)}
            />
          </div>

          <div style={{ textAlign: 'center' }}>
            <Button type="primary" onClick={store.doApply} disabled={disabled}>
              确认申请
            </Button>
          </div>
        </div>
      </HeaderView>
    )
  }
}
